var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcButtonPreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.25 7.75H7.57095L17.6875 5.07906C17.7833 5.05383 17.8731 5.00988 17.9518 4.94976C18.0305 4.88963 18.0965 4.81452 18.146 4.72876C18.1955 4.64299 18.2275 4.54827 18.2402 4.45006C18.2529 4.35186 18.2461 4.2521 18.22 4.15656L17.455 1.34406C17.3497 0.965673 17.0996 0.643996 16.7588 0.448696C16.4181 0.253397 16.0141 0.200198 15.6344 0.300622L1.3572 4.06937C1.1671 4.11872 0.98876 4.20549 0.832612 4.32462C0.676464 4.44374 0.54565 4.59282 0.447828 4.76312C0.349459 4.93134 0.285905 5.11761 0.260943 5.31087C0.23598 5.50413 0.250117 5.70043 0.302515 5.88812L1.00002 8.45875C1.00002 8.47187 1.00002 8.48593 1.00002 8.5V16.75C1.00002 17.1478 1.15805 17.5294 1.43935 17.8107C1.72066 18.092 2.10219 18.25 2.50002 18.25H17.5C17.8978 18.25 18.2794 18.092 18.5607 17.8107C18.842 17.5294 19 17.1478 19 16.75V8.5C19 8.30108 18.921 8.11032 18.7803 7.96967C18.6397 7.82902 18.4489 7.75 18.25 7.75ZM16.015 1.75L16.5775 3.81906L14.4569 4.38156L11.8206 2.85906L16.015 1.75ZM9.76283 3.4L12.3991 4.9225L8.93595 5.83656L6.2997 4.31594L9.76283 3.4ZM2.31908 7.58312L1.75658 5.51312L4.24095 4.85687L6.8772 6.38125L2.31908 7.58312ZM17.5 16.75H2.50002V9.25H17.5V16.75Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcButtonPreview);
export default __webpack_public_path__ + "static/media/ic_button_preview.a214db8d0575f2f1690f170daf0cf815.svg";
export { ForwardRef as ReactComponent };